import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { EuTimeTrackingConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { EuTimeTrackingService } from './api/euTimeTracking.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class EuTimeTrackingApiModule {
    public static forRoot(configurationFactory: () => EuTimeTrackingConfiguration): ModuleWithProviders<EuTimeTrackingApiModule> {
        return {
            ngModule: EuTimeTrackingApiModule,
            providers: [ { provide: EuTimeTrackingConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: EuTimeTrackingApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('EuTimeTrackingApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
